import { header } from "../../../../config/header";

export const useSchoolHeader = () => {
  return header;
};